import { useDispatch, useSelector } from "react-redux";
import styles from "../../../styles/Components/new-insight/signals-section/CurrentStrategyInfo.module.css";
import { FaLightbulb } from "react-icons/fa";
import { useEffect, useRef } from "react";
import {
  getStrategySignal,
  presentStrategyPack,
  setCurrentStrategy,
} from "../../../redux/new-insight/actions";
import { Tooltip } from "antd";
import { MdOutlineMoreHoriz } from "react-icons/md";
import { useSearchParams } from "react-router-dom";

export function pickMarketSystemStrategy(systemStrategies, market) {
  const wanted = market || "crypto";
  const forMarket = (systemStrategies || []).filter(
    (item) => (item?.market_type || "crypto") === wanted,
  );
  return (
    forMarket.find((item) =>
      String(item?.strategy_name || "")
        .toLowerCase()
        .includes("cryptocrispy"),
    ) ||
    forMarket[0] ||
    null
  );
}

function CurrentStrategyInfo() {
  const {
    main: { userData },
    newInsightState: { currentStrategy, systemStrategies, insightMarketType },
  } = useSelector((state) => state);
  const [searchParams, setSearchParams] = useSearchParams();

  const dispatch = useDispatch();
  const lastRequestedMarketRef = useRef("");

  const { name, label, tag } = presentStrategyPack(currentStrategy);
  const tagText = Array.isArray(tag) ? tag.join(", ") : tag;

  useEffect(() => {
    if (!userData?.email || !systemStrategies.length) return;
    const market = insightMarketType || "crypto";
    const cryptoCrispyStrategy = pickMarketSystemStrategy(
      systemStrategies,
      market,
    );
    if (!cryptoCrispyStrategy) {
      lastRequestedMarketRef.current = "";
      if (searchParams.get("strategy")) {
        searchParams.delete("strategy");
        setSearchParams(searchParams);
      }
      return;
    }

    const requestKey = `${market}|${cryptoCrispyStrategy.createdDate}`;
    if (
      lastRequestedMarketRef.current === requestKey &&
      currentStrategy?.createdDate === cryptoCrispyStrategy.createdDate
    ) {
      return;
    }
    lastRequestedMarketRef.current = requestKey;
    if (searchParams.get("strategy") !== cryptoCrispyStrategy.createdDate) {
      searchParams.set("strategy", cryptoCrispyStrategy.createdDate);
      setSearchParams(searchParams);
    }
    if (currentStrategy?.createdDate !== cryptoCrispyStrategy.createdDate) {
      dispatch(setCurrentStrategy(cryptoCrispyStrategy));
    }
    dispatch(
      getStrategySignal(
        userData["custom:custom_username"],
        userData?.email,
        cryptoCrispyStrategy?.createdDate,
        true,
        false,
        market,
      ),
    );
  }, [
    currentStrategy,
    dispatch,
    insightMarketType,
    searchParams,
    setSearchParams,
    systemStrategies,
    userData,
  ]);

  if (Object.keys(currentStrategy)?.length === 0) return null;

  return (
    <div className={styles.container}>
      <h4>
        <FaLightbulb color={"#f9ca24"} /> Current Strategy:
      </h4>
      <span className={styles.name} title="Name">
        {name}
      </span>
      {Number.isFinite(Number(currentStrategy?.goodness)) ? (
        <span className={styles.label} title="Goodness">
          Goodness {Math.round(Number(currentStrategy.goodness))}%
        </span>
      ) : null}
      {label && (
        <span className={styles.label} title="Label">
          {label}
        </span>
      )}
      {tagText && (
        <span className={styles.tag} title="Tag">
          {tagText}
        </span>
      )}

      {(label || tagText) && (
        <Tooltip
          title={`${label ? "Label: " + label : ""} ${
            tagText ? "Tag: " + tagText : ""
          }`}
          className={styles.tooltip}
          color="geekblue"
        >
          <MdOutlineMoreHoriz />
        </Tooltip>
      )}
    </div>
  );
}

export default CurrentStrategyInfo;
